/**
 * Remove the last stroke from a react-signature-canvas instance.
 * @param {import('react').RefObject<import('react-signature-canvas').default> | import('react-signature-canvas').default | null | undefined} signaturePad
 */
export function undoSignatureStroke(signaturePad) {
  const pad = signaturePad?.current ?? signaturePad;
  if (!pad || typeof pad.toData !== "function" || typeof pad.fromData !== "function") {
    return;
  }

  const strokes = pad.toData();
  if (!Array.isArray(strokes) || strokes.length === 0) {
    return;
  }

  const remaining = strokes.slice(0, -1);
  pad.clear();
  if (remaining.length > 0) {
    pad.fromData(remaining);
  }
}
